import React from 'react'
import { CiSearch } from 'react-icons/ci'
import { NavigateFunction } from 'react-router-dom'

import { Survey } from '../../api/services/surveys/types.ts'
import { SurveyTemplates } from '../../api/services/user_assignment_codes/types.ts'
import SurveyCheckbox from '../../components/assignmentCodes/SurveyCheckbox'

type TableColumn = {
  header: string
  accessor: string
  render?: (data: Survey) => JSX.Element
  className?: string
  classNameTd?: string
  sorted?: boolean
}

export const setSurveysTableColumns = (
  codeAssignment: string,
  surveyTemplates: SurveyTemplates[],
  toggleNumber: (value: number | null) => void
) => {
  const columns: TableColumn[] = [
    {
      header: 'Powiązana z kodem',
      accessor: 'survey_linked',
      render: (row: Survey) => (
        <SurveyCheckbox
          row={row}
          codeAssignment={codeAssignment}
          surveyTemplates={surveyTemplates}
          toggleNumber={toggleNumber}
        />
      ),
      className: 'text-center w-[150px]'
    },
    {
      header: 'Tytuł ankiety',
      accessor: 'title',
      render: (row: Survey) => <>{`${row.title}`}</>,
      className: 'w-auto',
      sorted: true
    },
    {
      header: 'Opis',
      accessor: 'description',
      render: (row: Survey) => <>{`${row.description}`}</>,
      className: 'w-auto'
    }
  ]

  return columns
}

export const setSurveysTableActions = (
  navigate: NavigateFunction,
  codeAssignmentID: number,
  codeAssignment: string,
  mainCodeId: number,
  checkedID: number[]
) => {
  const onClick = async (survey: Survey) => {
    navigate(
      `/application/assignment-codes/${codeAssignmentID}/survey-report/${survey.id}/`,
      {
        state: {
          codeAssignment,
          mainCodeId,
          survey
        }
      }
    )
  }

  return [
    {
      label: 'Raport',
      icon: <CiSearch className="text-lg" />,
      onClick: (row: Survey) => onClick(row),
      className: 'text-blue-500', disable: false,
      visible: (row: Survey) => {
        return checkedID.includes(row.id)
      }
    }
  ]
}
